export enum BackendResponseStatus {
    warning,
    error,
    success
}
